import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";

export const assetsApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "assetsApi",
    baseUrl: "/api/assets",
  }),
  reducerPath: "assetsApi",
  tagTypes: ["Asset"],
  endpoints: (builder) => ({
    getAsset: builder.query<any, { folderName: string; assetId: string }>({
      query: ({ folderName, assetId }) => `/${folderName}/${assetId}`,
    }),
    getAssetStream: builder.query<
      string,
      { folderName: string; assetId: string }
    >({
      query: ({ folderName, assetId }) => ({
        url: `/stream/${folderName}/${assetId}`,
        responseHandler: async (response) => {
          const blob = await response.blob();
          return URL.createObjectURL(blob);
        },
      }),
    }),
    uploadAsset: builder.mutation<any, { folderName: string; file: File }>({
      query: ({ folderName, file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: `/upload/${folderName}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Asset"],
    }),
    deleteAsset: builder.mutation<any, { folderName: string; assetId: string }>(
      {
        query: ({ folderName, assetId }) => ({
          url: `/${folderName}/${assetId}`,
          method: "DELETE",
        }),
      }
    ),
  }),
});

export const {
  useGetAssetQuery,
  useLazyGetAssetQuery,
  useGetAssetStreamQuery,
  useUploadAssetMutation,
  useDeleteAssetMutation,
} = assetsApi;
